// extracted by mini-css-extract-plugin
export var banner = "_b-0";